import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";

export class Ticket extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Ticket, v) : SKIP;
            },
            (v) => {
                return deserialize(Ticket, v) || new Ticket();
            }
        );
    }

    constructor(key = null, amount = 0) {
        super();
        this._key = key;
        this._amount = amount;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    valid() {

        if (!this.key || !this.key.valid() || this.key.any()) {
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.key || this.amount <= 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Ticket());
        } else if (target instanceof Ticket) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Ticket, {
    _key: alias("key", ItemKey.schema()),
    _amount: alias("amount", Schema.primitive())
});
